import React from 'react'

import { DialogConfirmation } from 'app/KinerjaPSPegawaiPage/components/DialogConfirmation'

type TDialogPraktikKinerjaConfirmationProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  btnFullWidth?: boolean
}
export const DialogPraktikKinerjaConfirmation: React.FC<
  TDialogPraktikKinerjaConfirmationProps
> = ({ isOpen, onClose, onConfirm, btnFullWidth = false }) => {
  return (
    <DialogConfirmation
      isOpen={isOpen}
      autoFocus={false}
      returnFocus={false}
      size="sm"
      title="Simpan Praktik Kinerja?"
      description="Setelah disimpan, Anda dapat ubah lagi sesuai kebutuhan atau langsung ajukan"
      ctaConfirm="Simpan"
      onClickConfirm={onConfirm}
      onClickCancel={onClose}
      btnFullWidth={btnFullWidth}
    />
  )
}
